"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTypeVersions = void 0;
const slim_1 = require("@blockprotocol/type-system/slim");
const react_1 = require("react");
const typed_values_1 = require("./typed-values");
const useTypeVersions = (typeId, typeOptions) => {
    return (0, react_1.useMemo)(() => {
        const baseUrl = (0, slim_1.extractBaseUrl)(typeId);
        const versions = (0, typed_values_1.typedValues)(typeOptions ?? {}).filter((type) => baseUrl === (0, slim_1.extractBaseUrl)(type.$id));
        const latestVersion = Math.max(...versions.map((version) => (0, slim_1.extractVersion)(version.$id)));
        return [(0, slim_1.extractVersion)(typeId), latestVersion, baseUrl];
    }, [typeId, typeOptions]);
};
exports.useTypeVersions = useTypeVersions;
